import React from 'react';
import { UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap';

const TeamSports = () => (
  <div>
    <h2>Team Sports</h2>
    <p>8 Channels of Premium Variety Pack Lite Content in HD. $4. **Requires Advanced Lite, Advanced or Ultra Package</p>
    <Button outline color="success" id="teamsportstoggle" style={{ marginBottom: '1rem' }}>
      Show/Hide Channel Listing
    </Button>
    <UncontrolledCollapse toggler="#teamsportstoggle">
      <Card>
        <CardBody>
          316 - Big Ten Network<br />
          317 - Big Ten Network Alternate<br />
          319 - PAC12<br />
          322 - ESPN Goal Line<br />
          323 - Fox College Sports Atlantic<br />
          324 - Fox College Sports Central<br />
          325 - Fox College Sports Pacific<br />
          329 - NFL RedZone<br />
        </CardBody>
      </Card>
    </UncontrolledCollapse>
  </div>
);

export default TeamSports;


// WEBPACK FOOTER //
// ./src/components/sections/services/tv/teamsports.js